import { API, API_2, APILocal, APIStaging } from "../config/axios";

class PanicType {
  getAllPanicTypes = async () => {
    const { data } = await API_2.get<IPanicTypes[]>(`PanicTypes`);
    return data;
  };
}
export default new PanicType();
